/**
 * Service Grid Modal
 *
 * Opens a shared modal when a .sg-modal-trigger tile is clicked.
 * Form HTML is pre-rendered server-side in hidden .sg-modal-data divs.
 * JS clones the content into the modal and pre-fills a GF field.
 */

(function () {
  const modal = document.getElementById('sg-modal');
  if (!modal) return;

  const backdrop  = modal.querySelector('.sg-modal__backdrop');
  const closeBtn  = modal.querySelector('.sg-modal__close');
  const headingEl = modal.querySelector('.sg-modal__heading');
  const bodyEl    = modal.querySelector('.sg-modal__body');

  // -------------------------------------------------------------------------
  // Open
  // -------------------------------------------------------------------------
  document.querySelectorAll('.sg-modal-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const dataId  = trigger.dataset.modalId     || '';
      const heading = trigger.dataset.modalHeading || '';
      const fieldId = trigger.dataset.modalFieldId || '';
      const value   = trigger.dataset.modalValue   || '';

      headingEl.textContent = heading;

      // Clone the pre-rendered form content into the modal body
      bodyEl.innerHTML = '';
      if (dataId) {
        const source = document.getElementById(dataId);
        if (source) {
          bodyEl.innerHTML = source.innerHTML;

          // Re-execute any inline scripts GF injected (needed for GF JS init)
          bodyEl.querySelectorAll('script').forEach((s) => {
            const script = document.createElement('script');
            if (s.src) {
              script.src = s.src;
            } else {
              script.textContent = s.textContent;
            }
            document.body.appendChild(script);
          });
        }
      }

      // Pre-fill the specified GF field with the service/industry name
      if (fieldId && value) {
        prefillField(fieldId, value);
      }

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    });
  });

  // -------------------------------------------------------------------------
  // Close
  // -------------------------------------------------------------------------
  function closeModal() {
    modal.classList.add('is-closing');
    modal.addEventListener('animationend', () => {
      modal.classList.remove('is-closing');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      bodyEl.innerHTML = '';
    }, { once: true });
  }

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
  });

  // -------------------------------------------------------------------------
  // Pre-fill a Gravity Forms field
  // GF renders inputs as: input[name="input_{fieldId}"]
  // -------------------------------------------------------------------------
  function prefillField(fieldId, value) {
    const attempt = (tries) => {
      const input = bodyEl.querySelector(
        `[name="input_${fieldId}"], [name="input_${fieldId}.1"]`
      );
      if (input) {
        input.value = value + ' Enquiry';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (tries > 0) {
        setTimeout(() => attempt(tries - 1), 50);
      }
    };
    attempt(5);
  }
})();
